export default __webpack_public_path__ + "assets/5199873625bf324818ea34c6a95e39e4.png";